import { requestToken } from "./request_method";

const BASE = `${process.env.REACT_APP_NODE_URL}/api/route-track`;

const routeTrackApi = {
  /**
   * Create or replace a route for a given employee + date.
   * payload: { date, employeeId?, stops: [{ name, address?, sequence_no?, latitude?, longitude? }] }
   */
  saveRoute(payload) {
    return requestToken.post(`${BASE}/routes`, payload);
  },

  /**
   * Get route (with stops) for a given date (defaults to today) and employee.
   * params: { date?, employeeId? }
   */
  getRouteForDay(params = {}) {
    return requestToken.get(`${BASE}/routes/today`, params);
  },

  /**
   * Update a single stop: toggle visited / skipped etc.
   * payload: { status?, notes?, actualArrivalTime? }
   */
  updateStop(stopId, payload) {
    return requestToken.patch(`${BASE}/stops/${stopId}`, payload);
  },

  /**
   * Grid view: list of all route stops for a month, exact date, or date range.
   * params: { date?, startDate?, endDate?, year?, month?, employeeId?, villageId? }
   */
  getRoutesGrid(params) {
    return requestToken.get(`${BASE}/routes-grid`, params);
  },

  /**
   * Summary grid: list of routes (one row per employee+day) for a month, exact date, or date range.
   * params: { date?, startDate?, endDate?, year?, month?, employeeId?, villageId? }
   */
  getRoutesSummary(params) {
    return requestToken.get(`${BASE}/routes-summary`, params);
  },

  /**
   * Geocode missing village master coordinates (saved to village table).
   * body: { villageId }
   */
  ensureVillageGeo(body) {
    return requestToken.post(`${BASE}/villages/ensure-geo`, body);
  },

  /** params: { date?, employeeId? } — village-level visited / not visited / skipped */
  getDailyReport(params = {}) {
    return requestToken.get(`${BASE}/daily-report`, params);
  },

  /** body: { date?, employeeId?, forAllEmployees?: true } — admin-only for broadcast */
  sendDailyReportWhatsapp(body) {
    return requestToken.post(`${BASE}/daily-report/whatsapp`, body);
  },

  /**
   * Delete a route for employee+date.
   * params: { date, employeeId? }
   */
  deleteRoute(params) {
    const qs = new URLSearchParams();
    if (params?.date) qs.set("date", params.date);
    if (params?.employeeId != null) qs.set("employeeId", String(params.employeeId));
    const url = `${BASE}/routes?${qs.toString()}`;
    return requestToken.delete(url);
  },
};

export default routeTrackApi;

